module.exports = __webpack_public_path__ + "static/media/autumnAkiu.c20e062f.jpg";